import React from 'react';
import { Hero } from '../components/Hero';
import { ValueProposition } from '../components/ValueProposition';
import { About } from '../components/About';
import { Portfolio } from '../components/Portfolio';
import { Process } from '../components/Process';
import { Testimonials } from '../components/Testimonials';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-150">
      <main data-id="element-151">
        <Hero data-id="element-152" />
        <ValueProposition data-id="element-153" />
        <About data-id="element-154" />
        <Portfolio data-id="element-155" />
        <Process data-id="element-156" />
        <Testimonials data-id="element-157" />
        <Contact data-id="element-158" />
      </main>
      <Footer data-id="element-159" />
    </div>;
}